import Col from '@loggi/ui/components/col';
import Text, {
  TEXT_SIZE_LARGE,
  TEXT_SIZE_REGULAR
} from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './alert-text.component.scss';

export default function AlertText({ title, description }) {
  return (
    <React.Fragment>
      <Col className={styles.textAlign}>
        <Text bold size={TEXT_SIZE_LARGE}>
          {title}
        </Text>
      </Col>
      <Col
        gutter={{ top: 'quarter', bottom: 'quarter' }}
        className={styles.textAlign}
      >
        <Text size={TEXT_SIZE_REGULAR} color={colors.type.INFO}>
          {description}
        </Text>
      </Col>
    </React.Fragment>
  );
}

AlertText.displayName = 'AlertText';

AlertText.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string
};

AlertText.defaultProps = {
  title: null,
  description: null
};
